import { useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Download } from 'lucide-react';
import { Select } from '../../components/ui/Select.js';
import { Button } from '../../components/ui/Button.js';
import { useAreas } from '../../hooks/useAreas.js';
import { exportCsvUrl } from '../../lib/api.js';
import { useToast } from '../../components/ui/Toast.js';

export const Route = createFileRoute('/_auth/exports')({
  component: ExportsPage,
});

const STAGE_OPTIONS = [
  { value: 'new',          label: 'New' },
  { value: 'sale',         label: 'Sale' },
  { value: 'sold',         label: 'Sold' },
  { value: 'rent',         label: 'Rent' },
  { value: 'rented',       label: 'Rented' },
  { value: 'potential',    label: 'Potential' },
  { value: 'unavailable',  label: 'Unavailable' },
  { value: 'no_sale',      label: 'No Sale' },
  { value: 'no_answer',    label: 'No Answer' },
  { value: 'wrong_number', label: 'Wrong Number' },
  { value: 'agent',        label: 'Agent' },
];

function ExportsPage() {
  const { toast } = useToast();
  const { data: areas } = useAreas();
  const [areaId, setAreaId] = useState('');
  const [stage, setStage] = useState('');

  const areaOptions = (areas ?? []).map((a) => ({ value: a.id, label: a.name }));

  function handleExport() {
    const url = exportCsvUrl({
      area_id: areaId || undefined,
      stage: stage || undefined,
    });
    window.open(url, '_blank');
    toast('Export download started — check your downloads folder', 'info');
  }

  return (
    <div className="max-w-lg mx-auto p-4">
      <h1 className="text-xl font-bold text-primary-text mb-1">Export CSV</h1>
      <p className="text-sm text-secondary mb-6">
        Download landlord data. Capped at 50,000 rows per export.
      </p>

      <div className="bg-white border border-border rounded-xl p-4 space-y-4">
        <Select
          placeholder="All areas"
          label="Filter by area"
          options={areaOptions as Array<{ value: string | number; label: string }>}
          value={areaId}
          onChange={(e) => setAreaId(e.target.value)}
        />
        <Select
          placeholder="All stages"
          label="Filter by stage"
          options={STAGE_OPTIONS}
          value={stage}
          onChange={(e) => setStage(e.target.value)}
        />

        <Button onClick={handleExport} className="w-full" size="lg">
          <Download className="w-4 h-4" />
          Download CSV
        </Button>
      </div>
    </div>
  );
}
